import { useEffect, useState } from "react";
import { CalendarDays, X } from "lucide-react";
import { api } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { RcCalendar, fromDay, toDay } from "@/components/RcCalendar";

export const EventDatePicker = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const [blocked, setBlocked] = useState([]);

  useEffect(() => {
    api.get("/calendar/blackout").then((r) => setBlocked(Array.isArray(r.data?.dates) ? r.data.dates.map(fromDay) : [])).catch(() => setBlocked([]));
  }, []);

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const label = value ? fromDay(value).toLocaleDateString("en-US", { weekday: "short", month: "long", day: "numeric", year: "numeric" }) : "Pick a date";

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <div className="relative">
        <PopoverTrigger asChild>
          <button type="button" className={`flex w-full items-center justify-between border-0 border-b border-rc-line2 bg-transparent py-3 text-left text-base outline-none transition-[border-color] focus:border-rc-copper ${value ? "text-rc-ink" : "text-rc-faint"}`} data-testid="inquiry-event-date-btn">
            {label}
            <CalendarDays className="h-4 w-4 text-rc-copper" />
          </button>
        </PopoverTrigger>
        {value && (
          <button type="button" onClick={() => onChange("")} className="absolute right-7 top-1/2 -translate-y-1/2 text-rc-muted hover:text-rc-ink" aria-label="Clear date" data-testid="inquiry-event-date-clear">
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
      <PopoverContent align="start" className="w-auto border-rc-line bg-rc-surface p-4 text-rc-ink" data-testid="inquiry-event-calendar">
        <RcCalendar
          mode="single"
          selected={value ? fromDay(value) : undefined}
          onSelect={(d) => { if (d) { onChange(toDay(d)); setOpen(false); } }}
          disabled={[{ before: today }, ...blocked]}
          modifiers={{ booked: blocked }}
          modifiersClassNames={{ booked: "!bg-rc-ink !text-rc-bg !no-underline !opacity-90" }}
        />
        <p className="mt-3 flex items-center gap-2 text-xs text-rc-muted"><span className="inline-block h-3 w-3 rounded-full bg-rc-ink" /> Already booked</p>
      </PopoverContent>
    </Popover>
  );
};
